import { makeStyles } from '@fluentui/react-components';
import { CARD_BORDER_RADIUS } from '@shared/constants/card.constants';

const useItemTableStyles = makeStyles({
  card: {
    borderRadius: CARD_BORDER_RADIUS,
    paddingTop: 0,
    paddingBottom: 0,
  },
  table: {
    borderSpacing: '0 10px',
    '& tr > :first-child': {
      borderTopLeftRadius: '8px',
      borderBottomLeftRadius: '8px',
    },
    '& tr > :last-child': {
      borderTopRightRadius: '8px',
      borderBottomRightRadius: '8px',
    },
    '& tr': {
      height: '48px',
    },
  },
  tableBody: {
    '& > :last-child': {
      borderBottom: 'none',
    },
  },
});

export default useItemTableStyles;
